/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Select,
  Table,
  AutoComplete,
  Input,
  Spin,
  Badge,
} from "antd";
import "./index.css";
import { DownloadOutlined } from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import {
  loadExpensesListRecordsMetaData,
  loadCashBankReportList,
} from "../../store/expenses/actions";
import DatePicker from "react-datepicker";
import api from "../../helpers";

const CashInReport = (props) => {
  const dispatch = useDispatch();

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const media = useMedia();

  const stockGetPayload = {
    organizationId: organizationId,
    page: 1,
    limit: 10,
  };

  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadCashBankReportList(stockGetPayload));
    dispatch(loadExpensesListRecordsMetaData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { cash_bank_reports = {}, expenseMetaData = {} } = useSelector(
    (state) => state.Expenses
  );

  //header columns
  const HeaderData = [
    {
      key: "createdAt",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "createdAt",
      width: 120,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.createdAt && text.createdAt}
        </p>
      ),
      sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },
    {
      key: "paymentNo",
      title: (
        <p className="header-purchase-invoice font-semibold">Payment No</p>
      ),
      dataIndex: "paymentNo",
      width: 115,
    },
    // {
    //   key: "expenseItem",
    //   title: (
    //     <p className="header-purchase-invoice font-semibold">Expense Items</p>
    //   ),
    //   dataIndex: "expenseItem",
    //   width: 130,
    // },
    {
      key: "partyName",
      title: (
        <p className="header-purchase-invoice font-semibold">Party Name</p>
      ),
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.partyName && text.partyName}
        </p>
      ),
      dataIndex: "partyName",
      width: 150,
    },
    // {
    //   key: "categoryName",
    //   title: <p className="header-purchase-invoice font-semibold">Category</p>,
    //   dataIndex: "categoryName",
    //   render: (record, text, row) => (
    //     <p className="header-purchase-invoice">{text.categoryName}</p>
    //   ),
    //   width: 140,
    // },
    {
      key: "paymentModeName",
      title: (
        <p className="header-purchase-invoice font-semibold">Payment Mode</p>
      ),
      dataIndex: "paymentModeName",
      render: (record, text, row) => (
        <p className="header-purchase-invoice">{text.paymentModeName}</p>
      ),
      width: 140,
    },
    {
      key: "balanceAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Balance Amount</p>
      ),
      dataIndex: "balanceAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.balanceAmount && text.balanceAmount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 150,
    },
    {
      key: "receivedAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Received Amount</p>
      ),
      dataIndex: "receivedAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.receivedAmount && text.receivedAmount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 150,
    },
    {
      key: "paidAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Paid Amount</p>
      ),
      dataIndex: "paidAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.paidAmount && text.paidAmount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 130,
    },

    // {
    //   key: "status",
    //   title: <p className="header-purchase-invoice font-semibold">Status</p>,
    //   dataIndex: "status",
    //   width: 130,
    // },
  ];

  //filters
  const [pageValue, setPageValue] = useState("");
  const [filteredValues, setFilteredValues] = useState("");
  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    var paymentModeId =
      !isEmpty(paymentModeList) || paymentModeList.length !== 0
        ? paymentModeList
        : "";

    let searchValue = {};
    searchValue.page = pageValue ? pageValue : 1;
    searchValue.limit = 10;
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }

    if (paymentModeId) {
      searchValue.paymentModeId = paymentModeId;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");

    setFilteredValues(searchValue);
    setTableLoading(true);
    dispatch(loadCashBankReportList(searchValue));
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [cashBankRows, setCashBankRows] = useState([
    {
      accountDetails: "",
      balanceAmount: "",
      createdAt: "",
      createdBy: "",
      isCash: "",
      paymentModeName: "",
      paidAmount: "",
      partyName: "",
      paymentDate: "",
      paymentModeId: "",
      paymentNo: "",
      receivedAmount: "",
      transActionType: "",
      transActionTypeId: "",
      updatedAt: "",
      _id: "",
      status: "",
    },
  ]);

  console.log(cash_bank_reports, "cash_bank_reports");
  const cashBankDataTable =
    !isEmpty(cash_bank_reports) &&
    cash_bank_reports.cashAndBankReports.length > 0
      ? cash_bank_reports.cashAndBankReports.map((data, index) => {
          return {
            key: index + 1,
            accountDetails: data.accountDetails,
            balanceAmount: data.balanceAmount,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            isCash: data.isCash,
            paymentModeName: data.mode,
            paidAmount: data.paidAmount,
            partyName: data.partyName,
            paymentDate: data.paymentDate,
            paymentModeId: data.paymentModeId,
            paymentNo: data.paymentNo,
            receivedAmount: data.receivedAmount,
            transActionType: data.transActionType,
            transActionTypeId: data.transActionTypeId,
            updatedAt: data.updatedAt,
            _id: data._id,
            status: (
              <Badge
                style={{
                  fontFamily: "Poppins",
                }}
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold capitalize rounded-md text-[#49a563] p-2"
                    : "bg-[#f1e7e9] font-semibold capitalize rounded-md text-[#d01717] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (cashBankDataTable && cashBankDataTable.length > 0) {
      setCashBankRows(cashBankDataTable);
    } else {
      setCashBankRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cash_bank_reports]);

  //paginations
  const handlePagination = (data) => {
    const filter = {
      page: data,
      limit: 10,
      organizationId: organizationId,
      expenseItemId: filteredValues ? filteredValues.expenseItemId : "",
      categoryId: filteredValues ? filteredValues.categoryId : "",
      paymentModeId: filteredValues ? filteredValues.paymentModeId : "",
      fromDate: filteredValues ? filteredValues.fromDate : "",
      toDate: filteredValues ? filteredValues.toDate : "",
    };
    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    setPageValue(data);
    dispatch(loadCashBankReportList(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = cashBankDataTable
      .filter((row) =>
        row.paymentModeName
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setCashBankRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    var paymentModeId =
      !isEmpty(paymentModeList) || paymentModeList.length !== 0
        ? paymentModeList
        : "";

    let searchValue = {};
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (paymentModeId) {
      searchValue.paymentModeId = paymentModeId;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");

    api
      .post(`/org/getcashandbankreportexcel`, searchValue)
      .then((response) => {
        const stockReportExcel =
          !isEmpty(response) && response.data.length > 0
            ? response.data.map((data, index) => {
                return {
                  key: index + 1,
                  accountDetails: data.accountDetails,
                  balanceAmount: data.balanceAmount,
                  createdAt: data.createdAt
                    ? moment(data.createdAt).format("DD-MM-YYYY")
                    : "",
                  createdBy: data.createdBy,
                  isCash: data.isCash,
                  paymentModeName: data.mode,
                  paidAmount: data.paidAmount,
                  partyName: data.partyName,
                  paymentDate: data.paymentDate,
                  paymentModeId: data.paymentModeId,
                  paymentNo: data.paymentNo,
                  receivedAmount: data.receivedAmount,
                  transActionType: data.transActionType,
                  transActionTypeId: data.transActionTypeId,
                  updatedAt: data.updatedAt,
                  _id: data._id,
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Payment No,Party Name, Payment Mode, Balance Amount, Received Amount, Paid Amount",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  createdAt,
                  paymentNo,
                  partyName,
                  paymentModeName,
                  balanceAmount,
                  receivedAmount,
                  paidAmount,
                } = user;
                acc.push([
                  key,
                  createdAt,
                  paymentNo,
                  partyName,
                  paymentModeName,
                  balanceAmount,
                  receivedAmount,
                  paidAmount,
                ]);

                return acc;
              }, [])
            : false;

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "CashBankReport.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Cash & Bank Report | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Cash & Bank Report
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          (windowDimensions.height > 767 && windowDimensions.height < 830)
            ? "add-ledger-statment-reports-large-device"
            : windowDimensions.height > 830 && windowDimensions.height < 900
            ? "add-ledger-statment-reports-extra-large-device"
            : windowDimensions.height > 900 && windowDimensions.height < 1000
            ? "add-expenses-statment-reports-extra-extra-large-device"
            : windowDimensions.height > 1000
            ? "add-expenses-statment-reports-extra-large-device"
            : "add-ledger-statment-reports"
        }
      >
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            (media === "md" ||
              media === "lg" ||
              media === "xl" ||
              media === "xxl") &&
            windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 bg-[#ffffff] h-[122px] rounded-md"
              : (media == "sm" || media == "xs") &&
                windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 h-[44%] pb-[20px] bg-[#ffffff] rounded-md"
              : "mt-2 pr-4 pl-4 pt-3 pb-2 mb-4 bg-[#ffffff] rounded-md"
          }
        >
          <Row
            className={
              windowDimensions.height > 700
                ? "pr-2 pl-2 pt-3 rounded-md"
                : "pr-2 pl-2 pt-3 pb-2 rounded-md"
            }
          >
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={paymentModeList}
                  onChange={(newValue) => setPaymentModeList(newValue)}
                  placeholder="Select Payment Mode"
                  options={
                    expenseMetaData ? expenseMetaData.paymentModeOptions : []
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  selected={fromDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[130%]"
                  }
                  toggleCalendarOnIconClick={true}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setFromDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  selected={toDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[130%]"
                  }
                  toggleCalendarOnIconClick={true}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  popperClassName={"z-10 ml-3"}
                  onChange={(date) => setToDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  showIcon
                  placeholderText="Select To Date"
                />
              )}
            </Col>
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              className={
                media == "sm" || media == "xs"
                  ? "pr-2 w-[100%] mt-3"
                  : "pr-2 mt-3"
              }
            >
              <Row
                className={
                  media == "sm" || media == "xs" ? "flex" : "flex justify-end"
                }
              >
                {/* <Col
                  md={12}
                  lg={12}
                  sm={24}
                  xs={24}
                  className="pl-0 md:pl-10 lg:pl-10 xl:pl-10"
                > */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      width:
                        media == "md"
                          ? "180px"
                          : media == "sm"
                          ? "300px"
                          : "250px",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    className={
                      media == "sm" || media == "xs" ? "flex w-[100%]" : "flex"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setPaymentModeList([]);
                        setTableLoading(true);
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 2000);
                        dispatch(loadCashBankReportList(stockGetPayload));
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                          : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                      }
                    >
                      Reset
                    </div>
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => applyFilters()}
                      className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#45bd4a] hover hover:bg-[green]"
                    >
                      Filter
                    </div>
                  </div>
                )}
                {/* </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            cashBankDataTable.length > 0
              ? "mt-[-5px] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && cashBankDataTable.length > 0
              ? "mt-[-5px] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                cashBankDataTable.length == 0
              ? "mt-[-136px] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && cashBankDataTable.length == 0
              ? "mt-[-215px] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] rounded-md"
          }
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={18}
                  xs={18}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Category"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            fontSize: "11px",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={18} xs={18} className="pr-1">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "180px",
                            paddingRight: media == "md" ? "20px" : "14px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "20px" : "0px",
                            height: "35px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={24}
                            xs={24}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                  "cursor-pointer border pt-[5px] pb-[5px] rounded-md border-1"
                              // : "cursor-pointer border pt-[5px] pb-[5px] sm:pl-[5px] md:pl-[10px] pl-[5px] lg:pl-[40px] xl:pl-[40px] xxl:pl-[40px] pr-[30px] rounded-md border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p
                                className={
                                  media == "sm" || media == "xs"
                                    ? "flex justify-center"
                                    : "flex justify-center"
                                }
                              >
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-8 pl-4 purchase-invoice-orders pb-12 pr-4"
                  : media === "md"
                  ? "mt-[-10px] pl-4 purchase-invoice-orders pb-12 pr-4"
                  : "pt-1 pl-4 purchase-invoice-orders pb-12 pr-4"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  cashBankRows &&
                  cashBankRows.length > 0 &&
                  !isEmpty(cashBankRows[0]._id)
                    ? cashBankRows
                    : []
                }
                rowClassName={"p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  // onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (e) => handlePagination(e),
                  // page
                  total: !isEmpty(search)
                    ? cashBankRows.length
                    : cash_bank_reports
                    ? cash_bank_reports.totalItems
                    : "",
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{
                  y: "100%",
                  x: cashBankDataTable.length > 0 ? 825 : "100%",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

CashInReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default CashInReport;
